export default __webpack_public_path__ + "static/media/qg.c65c2909.png";